var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoringOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51401 10.3249L0.512695 10.3244C0.773315 5.31738 4.92889 1.32422 9.99961 1.32422C15.0698 1.32422 19.2254 5.31686 19.4865 10.3234L18.4852 10.3239C18.3645 8.24414 17.4953 6.3042 16.0073 4.81616C14.4002 3.20908 12.2666 2.32404 9.99961 2.32404C5.48028 2.32404 1.77339 5.86945 1.51401 10.3249Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99981 10.8251L0 10.8241C0 5.30969 4.48639 0.824219 9.9999 0.824219C15.5133 0.824219 19.9993 5.30969 19.9998 10.8231L18 10.8241C17.9995 8.69012 17.1667 6.68237 15.654 5.16971C14.1414 3.65707 12.1334 2.82404 9.9999 2.82404C5.58864 2.82404 1.99981 6.41284 1.99981 10.8241V10.8251Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.4992L14.3 4.82422",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringOperationIcon);
export default __webpack_public_path__ + "static/media/ScoringOperationIcon.6961c734070c4caa53644f642ebb6c95.svg";
export { ForwardRef as ReactComponent };